var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDarkBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1938,
    height: 1041,
    viewBox: "0 0 1938 1041",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1587.51 520.623L1587.32 520.901L1587.51 521.179L1934.07 1039.9H1671.15L1323.75 520.901L1673.22 0.5H1936.14L1587.51 520.623Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M974.939 0.5H1237.85L1341.38 153.992L1211.51 352.125L974.939 0.5Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1356.92 866.294L1240.44 1039.86H977.528L1221.89 675.035L1356.92 866.294Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M613.507 520.623L613.321 520.901L613.507 521.179L960.07 1039.9H697.154L349.751 520.901L699.221 0.5H962.135L613.507 520.623Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.93902 0.5H263.851L367.38 153.992L237.507 352.125L0.93902 0.5Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M382.923 866.294L266.443 1039.86H3.52825L247.89 675.035L382.923 866.294Z",
    stroke: "#005296",
    strokeOpacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkBg);
export default __webpack_public_path__ + "static/media/dark_bg.a386ef5d1b88f222228ca8302b7c81f9.svg";
export { ForwardRef as ReactComponent };